export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f0c25bd2c5fbfdb56c34414f0a070df78a1822bc5&name=fetchTypeahead!'